const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex justify-center items-center">
      <img
        src="https://www.dpmarketingcommunications.com/wp-content/uploads/2016/11/404-Page-Featured-Image.png"
        width={1000}
      />
    </div>
  );
};

export default NotFoundPage;
